export const modalBodyWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 2,
  width: '100%',
};

export const modalStatusRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1.5,
  py: 1,
};

export const modalSectionLabelStyles = {
  textTransform: 'uppercase',
  letterSpacing: 0.4,
};

export const modalButtonRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
};

export const modalDescriptionFieldStyles = {
  width: '100%',
};

export const previewBoxStyles = {
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'grey.100',
  fontFamily: 'monospace',
  fontSize: '0.8125rem',
  color: 'text.primary',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

export const assumptionsWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'warning.light',
};

export const assumptionsListStyles = {
  listStyleType: 'disc',
  pl: 3,
  m: 0,
  '& > li': {
    mb: 0.25,
  },
};

export const validationErrorsWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'error.light',
};

export const validationErrorListStyles = {
  listStyleType: 'disc',
  pl: 3,
  m: 0,
  '& > li': {
    mb: 0.25,
  },
};

export const clarifyOptionListStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const clarifyOptionCardStyles = {
  display: 'block',
  width: '100%',
  textAlign: 'left',
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  bgcolor: 'background.paper',
  transition: 'border-color 120ms ease, background-color 120ms ease, box-shadow 120ms ease',
  '&:hover': {
    borderColor: 'primary.main',
    bgcolor: 'action.hover',
  },
  '&:focus-visible': {
    outline: ({ palette }) => `2px solid ${palette.primary.main}`,
    outlineOffset: 1,
    borderColor: 'primary.main',
  },
};

export const clarifyOptionCardRecommendedStyles = {
  borderColor: 'primary.main',
  bgcolor: 'action.selected',
};

export const clarifyOptionCardContentStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  px: 1.5,
  py: 1.25,
};

export const clarifyOptionCardHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const clarifyOptionRecommendedBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 0.75,
  py: 0.125,
  borderRadius: 0.5,
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
};

export const clarifyOptionDescriptionStyles = {
  display: 'block',
};

export const clarifyOptionValueStyles = {
  display: 'block',
  fontFamily: 'monospace',
  fontSize: '0.75rem',
  color: 'text.secondary',
  wordBreak: 'break-all',
};

export const clarifyFreeformToggleStyles = {
  alignSelf: 'flex-start',
  px: 0,
  py: 0.5,
  minWidth: 0,
  '&:hover': {
    bgcolor: 'transparent',
    textDecoration: 'underline',
  },
};

export const clarifyFreeformWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
};

export const workingRowSpacerStyles = {
  flex: 1,
};

export const refinePromptWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  borderRadius: 1,
  border: '1px dashed',
  borderColor: 'divider',
  bgcolor: 'background.paper',
};

export const showOptionsToggleRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const showOptionsHelperStyles = {
  ml: 0.5,
};

export const candidatesGridStyles = {
  display: 'grid',
  gridTemplateColumns: {
    xs: '1fr',
    md: 'repeat(auto-fit, minmax(280px, 1fr))',
  },
  gap: 1.5,
};

export const candidateCardStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  border: '1px solid',
  borderColor: 'divider',
  borderRadius: 1,
  bgcolor: 'background.paper',
};

export const candidateCardHeaderStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const candidateIndexBadgeStyles = {
  display: 'inline-flex',
  alignItems: 'center',
  px: 0.75,
  py: 0.125,
  borderRadius: 0.5,
  bgcolor: 'primary.main',
  color: 'primary.contrastText',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
};

export const candidateActionsRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  mt: 'auto',
};

export const feedbackWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  borderRadius: 1,
  bgcolor: 'action.hover',
};

export const feedbackHeaderRowStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  flexWrap: 'wrap',
};

export const feedbackThumbsRowStyles = {
  display: 'flex',
  gap: 1,
};

export const feedbackTagsRowStyles = {
  display: 'flex',
  gap: 0.5,
  flexWrap: 'wrap',
};

export const feedbackTagChipStyles = {
  px: 1,
  py: 0.5,
  borderRadius: 9999,
  border: '1px solid',
  borderColor: 'divider',
  bgcolor: 'background.paper',
  cursor: 'pointer',
  transition: 'border-color 120ms ease, background-color 120ms ease',
  '&:hover': {
    borderColor: 'primary.main',
  },
};

export const feedbackTagChipSelectedStyles = {
  borderColor: 'primary.main',
  bgcolor: 'action.selected',
};

export const feedbackNoteToggleStyles = {
  alignSelf: 'flex-start',
  px: 0,
  py: 0.25,
  minWidth: 0,
  '&:hover': {
    bgcolor: 'transparent',
    textDecoration: 'underline',
  },
};

export const feedbackNoteWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
};

export const feedbackActionRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
};

export const progressTrailWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 0.5,
  mt: 1,
  pl: 1,
  borderLeft: theme => `2px solid ${theme.palette.divider}`,
};

export const progressTrailItemStyles = {
  display: 'flex',
  alignItems: 'baseline',
  gap: 1,
};

export const progressTrailSelfCorrectStyles = {
  ...progressTrailItemStyles,
  color: 'warning.dark',
};

export const progressTrailDetailStyles = {
  fontFamily: 'monospace',
  fontSize: '0.75rem',
  color: 'text.secondary',
  whiteSpace: 'pre-wrap',
  wordBreak: 'break-word',
};

export const previewAddClauseWrapperStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  mt: 1,
};

export const previewAddClauseInputRowStyles = {
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  p: 1.5,
  borderRadius: 1,
  border: '1px dashed',
  borderColor: 'divider',
};

export const previewAddClauseActionsRowStyles = {
  display: 'flex',
  justifyContent: 'flex-end',
  gap: 1,
};

export const applyUndoToastStyles = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  p: 1.25,
  borderRadius: 1,
  bgcolor: 'success.light',
  color: 'success.contrastText',
};

export const applyUndoToastSpacerStyles = {
  flex: 1,
};
